import http from '../utils/http';

export enum enumType {
  // eslint-disable-next-line no-unused-vars
  empty = 1,
  // eslint-disable-next-line no-unused-vars
  format = 2,
  // eslint-disable-next-line no-unused-vars
  none = 3,
}

export declare type topicParams = {
  query: string
  pageSize?: number
  pageNumber?: number
  numCitesAll: number
  journalIF?: number
  sortBy?: number
}

export declare type topicResult = {
  authors: [],
  credibilityValue: number
  journalInfo: journalInfo
  numCitesAll: number
  originSentence: string
  paperTitle: string
  phrases: string[]
  publishedYear: string
  topicSentence: string
  topicSentenceId: string
  anaphorList: anaphors[]
  topicHoverSentence: string
  anaphorSpanList: number[]
}
declare type journalInfo = {
  IF: number
  name: string
}
declare type anaphors = {
  anaphor: string
  anaphorSpan: number[]
  antecedent: string
}

export declare type anaphors2 = {
  anaphor: string
  anaphorSpan: number[]
  antecedent: string
}

export declare type topicDetail = {
  topicSentenceId: string,
  topicSentence: string,
  phrases: string[],
  credibilityValue: number,
  abbreviations: {},
  sentenceSourceInfoEntity: sourceInfo,
  anaphorList: anaphors[]
}


export declare type sourceInfo = {
  paperId: string,
  paperTitle: string,
  rdPaperId: string,
  authors: string[],
  journalInfo: journalInfo,
  publishedYear: string,
  numCitesAll: number,
  origin: string,
  abstractString: string,
  originSentence: string,
  topicParagraph: string,
  hightLightPosition: {
    start: number,
    end: number
  }
}

export declare type topicSimilar = {
  sameTotal: number,
  similarTotal: number,
  similarArticleInfos: similarArticleInfo[],
  similarSentenceInfos: similarSentenceInfo[]
}

export declare type similarArticleInfo = {
  paperTitle: number,
  rdPaperId: string,
  abstractString: string,
  authors: string[],
  journalInfo: journalInfo,
  publishedYear: string,
  numCitesAll: number
}


export declare type similarSentenceInfo = [
  {
    topicSentenceId: string,
    topicSentence: string,
    paperId: string,
    entities: string[],
    credibilityValue: number
  }
]


const baseGoApi = process.env.NODE_ENV === 'production' ? '/api' : '';

export const getSearchResult = async (params: topicParams) => {
  const result = await http.post(`${baseGoApi}/search-assistant/v1/topic-sentence/search`, params);
  return result;
};

export const getTopicDetail = async (topicSentenceId: string) => {
  const result = await http.get(`${baseGoApi}/search-assistant/v1/topic-sentence-detail/topic`, { topicSentenceId });
  return result;
};

export const getTopicSimilar = async (topicSentenceId: string) => {
  const result = await http.get(`${baseGoApi}/search-assistant/v1/topic-sentence-detail/topic-verify`, { topicSentenceId });
  return result;
};

